import { DownloadOutlined } from '@ant-design/icons';
import { Button, Card, Col, Dropdown, Row, Typography } from 'antd';
import { QRCodeCanvas, QRCodeSVG } from 'qrcode.react';
import { Trans } from 'react-i18next';

import Config from '../../../app/config';
import useTypedParams from '../../../hooks/useTypedParams';
import { JobPostingId } from '../../../types';

interface PublicationQRCodeProps {
  externalPublication?: boolean;
  jobPostingName?: string;
}

//#region AntDesing QR Code download functions https://ant.design/components/qr-code#qr-code-demo-download

const doDownload = (url: string, fileName: string) => {
  const a = document.createElement('a');
  a.download = fileName;
  a.href = url;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

const downloadCanvasQRCode = (name: string) => {
  const canvas = document
    .getElementById('qrcode-container')
    ?.querySelector<HTMLCanvasElement>('canvas');

  if (canvas) {
    const url = canvas.toDataURL();
    doDownload(url, `${name} QRCode.png`);
  }
};

const downloadSvgQRCode = (name: string) => {
  const svg = document.getElementById('qrcode-container')?.querySelector<SVGElement>('svg');
  if (svg) {
    const svgData = new XMLSerializer().serializeToString(svg);
    const blob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(blob);

    doDownload(url, `${name} QRCode.svg`);
  }
};

//#endregion

const PublicationQRCode = ({ externalPublication, jobPostingName }: PublicationQRCodeProps) => {
  const { tenant, id } = useTypedParams({ tenant: String, id: JobPostingId });

  const jobPostingPortalLink = `${Config.REACT_APP_CAREER_PAGE_URL}${tenant}/${id}`;

  return (
    <>
      {externalPublication && (
        <div hidden id="qrcode-container">
          <QRCodeSVG value={jobPostingPortalLink} />
          <QRCodeCanvas value={jobPostingPortalLink} />
        </div>
      )}
      <Card>
        <Row justify="space-between" align="middle">
          <Col>
            <Typography.Text strong>
              <Trans>QR Code da vaga</Trans>
            </Typography.Text>
          </Col>
          <Col>
            <Dropdown
              menu={{
                items: [
                  {
                    key: 'png',
                    label: <a onClick={() => downloadCanvasQRCode(jobPostingName || '')}>png</a>,
                  },
                  {
                    key: 'svg',
                    label: <a onClick={() => downloadSvgQRCode(jobPostingName || '')}>svg</a>,
                  },
                ],
              }}
              disabled={!externalPublication}
            >
              <Button icon={<DownloadOutlined />}>
                {' '}
                <Trans>Baixar</Trans>
              </Button>
            </Dropdown>
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default PublicationQRCode;
